import script from "./employee-salary.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-salary.vue?vue&type=script&setup=true&lang=js"

import "./employee-salary.vue?vue&type=style&index=0&id=b6ff22a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6ff22a8"]])

export default __exports__